module.exports = {
  title: 'École du bien naitre',
}
